import React from 'react';
import { Page } from '../Page';
import { Dumbbell, Shield, Sparkles, Activity } from 'lucide-react';
export function Page9() {
  return <Page pageNumber={25} variant="light" data-id="element-686">
      <div className="flex flex-col h-full" data-id="element-687">
        {/* Hero Image Header */}
        <div className="relative h-[320px] -mx-12 -mt-10 mb-6 overflow-hidden" data-id="element-688">
          <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1000&q=80" alt="Weight lifting gym" className="w-full h-full object-cover" data-id="element-689" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-690" />

          <div className="absolute bottom-0 left-12 right-12 pb-6" data-id="element-691">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-692">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-693">
              Weight <span className="text-tealslate" data-id="element-694">Lifting</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6 max-w-2xl" data-id="element-695">
          When you lose weight, you lose both fat and muscle. GLP-1 medications
          accelerate this process. If you do not actively signal your body to
          keep your muscle, you will lose it. Weight lifting is that signal.
        </p>

        <div className="grid grid-cols-2 gap-8 mb-6" data-id="element-696">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center flex flex-col justify-center h-fit" data-id="element-697">
            <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-698">
              The Goal
            </h2>
            <div className="text-3xl font-serif text-[#1F1F1F] mb-3" data-id="element-699">
              2 Times
              <br data-id="element-700" />
              Per Week
            </div>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-701">
              A full-body workout hitting muscles from your shoulders to your
              calves. Each session should work your whole body.
            </p>
          </div>

          <div className="space-y-4" data-id="element-702">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3 border-b border-[#D8D8D0] pb-2" data-id="element-703">
              Why It's Essential
            </h2>
            <div className="space-y-3" data-id="element-704">
              <div className="flex items-start gap-3" data-id="element-705">
                <Shield className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-706" />
                <div data-id="element-707">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-708">
                    Protect Muscles
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-709">
                    Preserve your strength and metabolism while losing weight.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-710">
                <Sparkles className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-711" />
                <div data-id="element-712">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-713">
                    Skin Elasticity
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-714">
                    Building muscle helps reduce the appearance of loose skin.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-715">
                <Dumbbell className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-716" />
                <div data-id="element-717">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-718">
                    Toned Appearance
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-719">
                    Give your body a firmer, more defined look as the fat comes
                    off.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-720">
                <Activity className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-721" />
                <div data-id="element-722">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-723">
                    Medication Synergy
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-724">
                    Improves insulin sensitivity, helping your GLP-1 work
                    better.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-725">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex gap-4 items-center w-full" data-id="element-726">
            <div className="flex-1" data-id="element-727">
              <h3 className="font-serif text-base text-[#1F1F1F] mb-1" data-id="element-728">
                Need a Structured Program?
              </h3>
              <p className="text-[11px] text-[#7A7A70] leading-[1.5]" data-id="element-729">
                If you're looking for a personalized workout plan from me, check
                out my training app below! Try it free for one month with code{' '}
                <strong className="text-[#1F1F1F]" data-id="element-730">ONEMONTH</strong>. After
                that, it's $6.99 per month and gives you access to a full
                exercise library, workout tracking, and guidance on how to
                maximize results.
              </p>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/4sEENWegwxqKTrFHmP9mzr/Untitled_1.png" alt="Training App QR Code" className="w-12 h-12 shrink-0" data-id="element-731" />
          </div>
        </div>
      </div>
    </Page>;
}